export const FEATURE_TAGS = [
  { label: 'Free Kundli', path: 'M15 12h-5M15 8h-5M19 17V5a2 2 0 0 0-2-2H4' },
  {
    label: 'Kundli Matching',
    paths: [
      'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z',
      'M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66',
      'm18 15-2-2M15 18l-2-2',
    ],
  },
  {
    label: 'Panchang & Festivals',
    path: 'M8 2v4M16 2v4',
    rect: { x: 3, y: 4, width: 18, height: 18, rx: 2 },
    extraPath: 'M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01',
  },
  {
    label: 'Daily Lucky Picks',
    dots: [
      { cx: 13.5, cy: 6.5 },
      { cx: 17.5, cy: 10.5 },
      { cx: 8.5, cy: 7.5 },
      { cx: 6.5, cy: 12.5 },
    ],
    path: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z',
  },
  { label: 'Birth Number', path: 'M12 22V12M12 12C12 12 7 10 7 5a5 5 0 0 1 10 0c0 5-5 7-5 7Z' },
]

export const WHEEL_SEGMENTS = [
  { fill: '#3B0D0D', d: 'M100 100 L100 4 A96 96 0 0 1 167.88 32.12 Z' },
  { fill: '#5C1A08', d: 'M100 100 L167.88 32.12 A96 96 0 0 1 196 100 Z' },
  { fill: '#7B3008', d: 'M100 100 L196 100 A96 96 0 0 1 167.88 167.88 Z' },
  { fill: '#4A1A00', d: 'M100 100 L167.88 167.88 A96 96 0 0 1 100 196 Z' },
  { fill: '#2A0E1A', d: 'M100 100 L100 196 A96 96 0 0 1 32.12 167.88 Z' },
  { fill: '#5E1E0C', d: 'M100 100 L32.12 167.88 A96 96 0 0 1 4 100 Z' },
  { fill: '#3D1A04', d: 'M100 100 L4 100 A96 96 0 0 1 32.12 32.12 Z' },
  { fill: '#1E0A28', d: 'M100 100 L32.12 32.12 A96 96 0 0 1 100 4 Z' },
]

export const WHEEL_EMOJI = [
  { angle: 22.5, icon: '🔮' },
  { angle: 67.5, icon: '💰' },
  { angle: 112.5, icon: '🏡' },
  { angle: 157.5, icon: '📿' },
  { angle: 202.5, icon: '🌿' },
  { angle: 247.5, icon: '🧭' },
  { angle: 292.5, icon: '📅' },
  { angle: 337.5, icon: '🏛️' },
]
